var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingMeter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visuel/pending") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visuel/pending",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#DDD3F1",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "bi:question",
    transform: "translate(2, 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56875,7.2325 C6.56529144,7.31408873 6.59566478,7.39348667 6.65269425,7.45193597 C6.70972373,7.51038527 6.7883509,7.54270153 6.87,7.54125 L7.90125,7.54125 C8.07375,7.54125 8.21125,7.4 8.23375,7.22875 C8.34625,6.40875 8.90875,5.81125 9.91125,5.81125 C10.76875,5.81125 11.55375,6.24 11.55375,7.27125 C11.55375,8.065 11.08625,8.43 10.3475,8.985 C9.50625,9.59625 8.84,10.31 8.8875,11.46875 L8.89125,11.74 C8.89398048,11.9106332 9.03309493,12.0475 9.20375,12.0475 L10.2175,12.0475 C10.390089,12.0475 10.53,11.907589 10.53,11.735 L10.53,11.60375 C10.53,10.70625 10.87125,10.445 11.7925,9.74625 C12.55375,9.1675 13.3475,8.525 13.3475,7.17625 C13.3475,5.2875 11.7525,4.375 10.00625,4.375 C8.4225,4.375 6.6875,5.1125 6.56875,7.2325 L6.56875,7.2325 Z M8.515,14.43625 C8.515,15.1025 9.04625,15.595 9.7775,15.595 C10.53875,15.595 11.0625,15.1025 11.0625,14.43625 C11.0625,13.74625 10.5375,13.26125 9.77625,13.26125 C9.04625,13.26125 8.515,13.74625 8.515,14.43625 Z",
    id: "Shape",
    fill: "#5A2C71",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingMeter);
export default __webpack_public_path__ + "static/media/pending-meter.157c8853f4f15afb37aaa9bb568ae060.svg";
export { ForwardRef as ReactComponent };